import { DeliverableItem } from '../types';

interface DeliverablesSectionProps {
  items: DeliverableItem[];
  onViewExample: () => void;
}

export default function DeliverablesSection({ items, onViewExample }: DeliverablesSectionProps) {
  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="bg-white border border-gray-200 rounded-2xl p-10">
          <div className="flex items-start justify-between gap-8">
            <div className="flex-1">
              <h3 className="text-xl font-bold text-gray-900 mb-6">你能拿到什么</h3>
              <div className="space-y-4">
                {items.map((item, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center rounded-full bg-teal-50 text-[#14B8A6] mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-sm"></i>
                    </div>
                    <span className="text-sm text-gray-700">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
            <button
              onClick={onViewExample}
              className="px-6 py-3 bg-[#14B8A6] text-white text-sm font-medium rounded-full hover:bg-teal-600 transition-all cursor-pointer whitespace-nowrap"
            >
              查看示例
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}